import React, { Dispatch, DispatchWithoutAction, FC, ReactNode, useContext } from 'react'
import classNames from 'classnames'
import { RocketLaunchIcon } from '@heroicons/react/20/solid'
import { MessagesContext } from '../common/intl/MessagesContext'
import { ArrowPathIcon } from '@heroicons/react/24/outline'

interface Props {
  title: ReactNode
  description?: ReadonlyArray<ReactNode> | null
  className?: string
  startLoading?: boolean
  onStartCLick?: DispatchWithoutAction
  demoLoading?: boolean
  onDemoCLick?: DispatchWithoutAction
  autostart?: boolean
  setAutostart?: Dispatch<boolean>
}

export const LandingHero: FC<Props> = ({
  title,
  description,
  className,
  startLoading,
  onStartCLick,
  demoLoading,
  onDemoCLick,
  autostart,
  setAutostart,
}) => {
  const { test } = useContext(MessagesContext)

  return (
    <div className={classNames('flex bg-white py-44', className)}>
      <div className="container">
        <div className="text-center">
          <h1 className="wrap-balance mb-4 text-5xl font-extrabold leading-none tracking-tight xl:text-6xl">
            {title}
          </h1>

          <div className="mx-auto my-8 max-w-xl text-center">
            {description?.map((line, index) => (
              <div
                className="mb-3 font-light text-gray-500 md:text-lg lg:mb-3 lg:text-lg"
                key={index}
              >
                {line}
              </div>
            ))}
          </div>

          <div className="flex justify-center gap-4">
            {onStartCLick && (
              <button
                className="inline-flex items-center justify-center gap-3 rounded-lg bg-blue-700 py-3 pl-6 pr-8 text-center text-lg font-medium text-white shadow-md hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 disabled:shadow-none disabled:hover:bg-blue-700"
                onClick={onStartCLick}
                disabled={startLoading}
              >
                {startLoading ? (
                  <>
                    <ArrowPathIcon className="h-5 w-5 animate-spin" />

                    {test?.loading}
                  </>
                ) : (
                  <>
                    <RocketLaunchIcon className="h-5 w-5" />

                    {test?.hero?.start}
                  </>
                )}
              </button>
            )}

            {onDemoCLick && (
              <button
                className="inline-flex items-center justify-center rounded-lg border border-gray-300 px-8 py-3 text-center text-lg font-medium text-gray-900 hover:bg-gray-50 focus:bg-gray-50 active:shadow-inner"
                onClick={onDemoCLick}
              >
                {test?.hero?.try}
              </button>
            )}
          </div>

          {setAutostart && (
            <label className="relative my-10 inline-flex cursor-pointer items-center">
              <input
                type="checkbox"
                checked={autostart}
                className="peer sr-only"
                onChange={() => setAutostart(!autostart)}
              />
              <div className="peer h-6 w-11 rounded-full bg-gray-200 after:absolute after:left-[2px] after:top-0.5 after:h-5 after:w-5 after:rounded-full after:border after:border-gray-300 after:bg-white after:transition-all after:content-[''] peer-checked:bg-blue-700 peer-checked:after:translate-x-full peer-checked:after:border-white peer-focus:ring-4 peer-focus:ring-blue-300"></div>
              <span className="ml-3 text-sm text-gray-900">{test?.hero?.autostart}</span>
            </label>
          )}
        </div>
      </div>
    </div>
  )
}
